import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const UpdateSubscriptionStatus = async (status,navigate) => {
  const accesstoken = getToken();
  
  if (accesstoken) {
    try {      

        let Payload = {
            status: status,            
        };

      const response = await fetch(`${dev_baseUrl}/Subscription/UpdateSubscriptionStatus`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Payload),
      });
      
      const data = await response.json();        

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else {        
        return data || []; 
      }      
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};
